import "core-js/modules/es.array.push.js";
import satisfaction from "../../assets/imgs/satisfaction.png";
import soso from "../../assets/imgs/soso.png";
import nosatisfaction from "../../assets/imgs/nosatisfaction.png";
import { useRoute, useRouter } from "vue-router";
import { onMounted, getCurrentInstance, reactive } from "vue";
import { ElMessage } from "element-plus";
export default {
  name: "evaluatedetail",
  setup() {
    const router = useRouter();
    const route = useRoute();
    const internal = getCurrentInstance();
    const globalProperties = internal?.appContext.config.globalProperties;
    const data = reactive({
      degreePraise: 0,
      level: [{
        src: satisfaction,
        label: "非常满意"
      }, {
        src: soso,
        label: "一般般"
      }, {
        src: nosatisfaction,
        label: "不满意"
      }],
      list: [],
      evaluationContent: []
    });
    onMounted(() => {
      selectEvaluationByType();
    });
    const selectEvaluationByType = async () => {
      data.list = await globalProperties.$api.selectCommonAppraise();
    };
    const setDegreePraise = index => {
      data.degreePraise = index;
    };
    const handleEvaluationOrder = async () => {
      const params = {
        evaluationContent: data.evaluationContent.join(";"),
        evaluationStar: data.degreePraise,
        orderId: route.query.orderId,
        receiveUserId: route.query.receiveUserId
      };
      var res = await globalProperties.$api.saveCustomerEvaluation(params);
      if (res) {
        ElMessage({
          message: "评价成功",
          type: "success"
        });
        router.back(-1);
      }
    };
    const setEvaluationContent = value => {
      const index = data.evaluationContent.indexOf(value);
      if (index == -1) {
        data.evaluationContent.push(value);
      } else {
        data.evaluationContent.splice(index, 1);
      }
    };
    return {
      data,
      setDegreePraise,
      setEvaluationContent,
      handleEvaluationOrder
    };
  }
};